import { forwardRef } from 'react';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import H2 from '@base/H2/H2';
import Paper from '@base/Paper/Paper';
import { Spacings } from '@styles/index';
import pushRoute from '@utils/pushRoute';
import Breadcrumbs from '../../Common/Breadcrumbs';

const Wrapper = styled(Paper)`
  grid-column: span 24;
  margin-bottom: ${Spacings.SPACING_6B};
  padding-bottom: ${Spacings.SPACING_6B};
  padding-top: ${Spacings.SPACING_4B};
  height: fit-content;
`;

const StyledH2 = styled(H2)`
  margin-top: ${Spacings.SPACING_6B};
`;

const Header = forwardRef((_, ref) => {
  const { query, pathname } = useRouter();
  const { quizUID, quizSlug } = query;

  const handleOnBackClick = () => {
    return pushRoute(
      {
        pathname,
        query: {
          quizUID,
          quizSlug
        }
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <Wrapper ref={ref}>
      <Breadcrumbs type="quiz" useBackClick onBackClick={handleOnBackClick} />
      <StyledH2>Instructions</StyledH2>
    </Wrapper>
  );
});

Header.displayName = 'Header';

export default Header;
